import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const services = [
  {
    title: "Document Intelligence & Web Scraping",
    description: "Extract, structure, and optimize critical information from PDFs, websites, and databases using advanced scraping techniques and AI models.",
    icon: "📄"
  },
  {
    title: "Custom AI Chatbots",
    description: "Develop conversational agents capable of understanding context, suggesting intelligent responses, and learning continuously from user feedback loops.",
    icon: "🤖"
  },
  {
    title: "Business & Marketing Automation with n8n",
    description: "Automate your business and marketing workflows with n8n — from lead generation to automatic client responses, reservation management, CRM updates, and personalized campaigns — all without manual effort.",
    icon: "🔄"
  },

  {
    title: "Full-Stack Web Applications",
    description: "Build scalable, modern applications using MongoDB, Express, React, and Node.js — optimized for performance, UX, and real-time data interactions.",
    icon: "🌐"
  },
  {
    title: "Smart Data Extraction",
    description: "Turn web data into growth. I scrape, structure, and analyze information to build AI-powered dashboards and predictions that drive smarter decisions.",
    icon: "📊"
  }
];

const Services = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <section id="services" className="py-20 bg-gradient-to-br from-gray-50 via-white to-blue-50 dark:from-gray-900 dark:via-gray-900 dark:to-gray-800">
      <div className="container mx-auto px-4">
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl font-bold mb-4 text-dark">What I Do</h2>
          <p className="text-xl text-gray-600">My Expertise</p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="group relative bg-white/80 dark:bg-gray-800/80 backdrop-blur rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all border border-gray-100/60 dark:border-gray-700/40 hover:-translate-y-1 neo-surface"
            >
              <div className="absolute inset-0 rounded-2xl pointer-events-none" style={{ background: 'linear-gradient(120deg, rgba(99,102,241,0.12), rgba(59,130,246,0.12))' }} />
              <div className="relative">
                <div className="text-4xl mb-4 inline-flex p-3 rounded-xl bg-gradient-to-br from-blue-50 to-purple-50 dark:from-gray-700 dark:to-gray-700">
                  {service.icon}
                </div>
                <h3 className="text-xl font-semibold mb-3 text-dark dark:text-white group-hover:text-blue-700 dark:group-hover:text-blue-400 transition-colors">{service.title}</h3>
                <p className="text-gray-600 dark:text-gray-300">{service.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services; 